import { createFileRoute } from "@tanstack/react-router";

import { ConnectorsPage } from "../components/settings/ConnectorsPage";

function SettingsConnectorsRoute() {
  return <ConnectorsPage />;
}

export const Route = createFileRoute("/settings/connectors")({
  component: SettingsConnectorsRoute,
});
